import React, { useEffect, useRef, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { images } from '../data/mockData';

const PackagingSection = ({ content }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="packaging"
      ref={sectionRef}
      className="py-32 bg-white relative overflow-hidden"
    >
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
          {/* Image with 3D effect */}
          <div
            className={`relative transition-all duration-1000 ${
              isVisible
                ? 'opacity-100 translate-x-0'
                : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full bg-emerald-100 rounded-2xl -z-10" />
              <img
                src={images.logistics[0]}
                alt="Packaging"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>

          {/* Content */}
          <div
            className={`transition-all duration-1000 delay-200 ${
              isVisible
                ? 'opacity-100 translate-x-0'
                : 'opacity-0 translate-x-10'
            }`}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              {content.packaging.title}
            </h2>
            <p className="text-xl text-slate-600 mb-4">
              {content.packaging.subtitle}
            </p>
            <p className="text-slate-600 leading-relaxed mb-8">
              {content.packaging.description}
            </p>

            {/* Features List */}
            <div className="space-y-4">
              {content.packaging.features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-3"
                  style={{ transitionDelay: `${index * 100 + 400}ms` }}
                >
                  <CheckCircle2 className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackagingSection;
